module.exports = __webpack_public_path__ + "img/register.e59b77e8.png";